// OAuth flow -> It goes after the calendar selection page.
// ICS calendar flow -> It goes after the subscriber form filling up.
import {
    animateInAlmostDone,
    animateOauthLoading,
} from '../../animations/animate';

export default async function subscribeFromForm () {
    const appStore = this.env.appStore;
    const statesStore = this.env.uiStatesStore;

    // use appStore to navigate to the correct view
    if (appStore.selectedCalendar === 'apple' ||
        appStore.selectedCalendar === 'outlook'
    ) {
        animateInAlmostDone(this.env);
    } else {
        // else also includes outlook-new and ics
        animateOauthLoading(this.env);
    }
    
    await this.subscribe({
        selectedCalendarValue: statesStore.selectedCalendar.toLowerCase(),
    });
}
